class quickAtc extends HTMLElement {
    constructor() {
        super();
        this.addToCartFn();
    }

    addToCartFn = () => {
        this.addEventListener('click', (e) => {
            const data = { quantity: 1, id: e.currentTarget.dataset.variantId };
            const pHandle = e.currentTarget.dataset.pHandle;
            this.classList.add('loading');
            fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data),
                })
                .then((response) => response.json())
                .then((data) => {
                 const autoAddSettings = window.autoAddSettings || {}; // Fallback to empty object
const autoAddThreshold = autoAddSettings.threshold;
const autoAddProduct = autoAddSettings.autoAddProduct;
const collectionProducts = autoAddSettings.collectionProducts;
                                     if (typeof autoAddThreshold !== "undefined" && 
    typeof autoAddProduct !== "undefined" && 
    Array.isArray(collectionProducts) && collectionProducts.length > 0) {
                     fetch("/cart.js")
                      .then(response => response.json())
                      .then(cart => {
                          let cartTotal = cart.total_price / 100;
                          let hasCollectionProduct = cart.items.some(item => collectionProducts.includes(item.handle));
          
                          console.log("Cart total:", cartTotal);
                          console.log("Has collection product:", hasCollectionProduct);
          
                          let productExists = cart.items.some(item => item.id === autoAddProduct);
          
                          if (cartTotal >= autoAddThreshold && hasCollectionProduct && !productExists) {
                              fetch("/cart/add.js", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    id: autoAddProduct, // Using variant ID instead of product ID
                                    quantity: 1
                                })
                            })
                            .then(response => response.json())
                            .then(() => {
                                console.log("Auto-added product to cart");
                              ht("quick-cart:updated");
                              console.log('grid yessss')
                                // location.reload(); // Refresh to update cart
                            })
                            .catch(error => console.error("Error adding product:", error));
                            }
                        });
                                        }
                    this.classList.remove('loading');
                    fetch('/cart/?section_id=purchase-confirmation-popup-item', {
                            method: 'GET'
                        })
                        .then(res => res.text())
                        .then(data => {

                          
                            // append purchase confirmation popup
                            const productConfirmPopEle = document.querySelector('[data-section-id="quick-cart"]');
                            const productConfirmPopWrapper = document.querySelector('.quick-cart__wrapper');
                            productConfirmPopWrapper.classList.add('active');
                            productConfirmPopEle.classList.add('animation--quick-cart-revealed');

                            window.theme.offerSecSlider();
                            // freeshipping bar
                            this.freeShipStatus('[data-purchase-confirmation-popup] .free-shipping-bar');


                        })
                        .catch(err => console.error('Error:', err))


                    // append data on cart drawer
                    fetch('/cart?section_id=quick-cart', {
                            method: 'GET'
                        })
                        .then(res => res.text())
                        .then(data => {

                            const quickCartTrigger = document.querySelector('.quick-cart__container');
                            // Initialize the DOM parser
                            const parser = new DOMParser();
                            const cartData = parser.parseFromString(data, "text/html");
                            const appendData = cartData.querySelector('.quick-cart__container').innerHTML;
                            quickCartTrigger.innerHTML = appendData;

                            // cart count on header
                            const cardCount = parseInt(cartData.querySelector('.quick-cart__heading sup').textContent);
                            if (cardCount) {
                                document.querySelectorAll('[data-js-cart-count]').forEach(counter => {
                                    counter.textContent = cardCount;
                                })
                            }

                            // freeshipping bar
                            this.freeShipStatus('.quick-cart .free-shipping-bar');

                        })
                        .catch(err => console.log('Error:', err))

                })
                .catch((error) => {
                    console.error('Error:', error);
                })
        })
    }

    freeShipStatus = ($widget) => {
        const shippingBar = document.querySelector($widget);
        if (shippingBar) {
            const shippingBarTitle = shippingBar.querySelector('.free-shipping-bar__message'),
                cartTotal = parseInt(shippingBar.dataset.cartTotal),
                thresholdInCents = parseInt(shippingBar.dataset.threshold),
                successMsg = shippingBar.dataset.freeShippingSuccessMessage,
                pendingMsg = shippingBar.dataset.freeShippingPendingMessage;
            shippingBar.classList.add('free-shipping-bar--loaded');
            if ((cartTotal / 100) >= thresholdInCents) {
                shippingBar.classList.add('free-shipping-bar--success');
                shippingBarTitle.innerHTML = successMsg;
            } else {
                const calcRemainAmmount = Math.abs(thresholdInCents - (cartTotal / 100)).toFixed(2);
                const remainAmmount = window.theme.moneyFormat.replace('{{amount}}', `${calcRemainAmmount}`)

                var pendMsg = pendingMsg.replace('{{ remaining_amount }}', `<span class="fs-body-bold">${remainAmmount}</span>`);
                console.log(pendMsg);
                shippingBarTitle.innerHTML = pendMsg;

                // progressbar on status
                const progressWidth = ((cartTotal / 100) < thresholdInCents) ? cartTotal / thresholdInCents : 100;
                shippingBar.querySelector('.free-shipping-bar__bar').style.setProperty("--progress-width", `${progressWidth}%`);

            }
        }
    }
}

customElements.define('quick-atc', quickAtc)